module.exports = __webpack_public_path__ + "img/teeth.8bd4f75f.svg";